import React from 'react';

import Doc from '@ast/magma/components/icon/icons/Doc';

import { FieldInfoGroupField } from '@app/common/configurable-wizards';
import { FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { isFieldInfoGroupField } from '@app/common/configurable-wizards/utils';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';

import { ProfileAndSecurityFieldsListItem } from '../../FieldsListItem';

export const userEventsLogsField = {
  description: null,
  id: 'UserEventLogs',
  isEnabled: true,
  isSubmittable: false,
  label: null,
  name: null,
  type: 'FIELDINFOGROUP',
};

export const DisplayUserEventLogsField: FieldComponent<FieldInfoGroupField> = () => {
  const { t } = useUserSettingsTranslation();
  return (
    <ProfileAndSecurityFieldsListItem
      icon={<Doc />}
      title={t(
        'display-user-event-log-field.title|Event logs label',
        'Event Logs',
      )}
      value=""
    />
  );
};

export const DisplayUserEventLogsFieldLocator: FieldLocator = ({ field }) => (
  isFieldInfoGroupField(field) && field.id === userEventsLogsField.id
    ? DisplayUserEventLogsField
    : undefined
);
